/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const resolveChatParticipantsBodyInvitationIdsDefault = [];
export const resolveChatParticipantsBodyInvitationIdsMax = 100;

export const resolveChatParticipantsBodyReachUserIdsDefault = [];
export const resolveChatParticipantsBodyReachUserIdsMax = 100;

export const ResolveChatParticipantsBody = zod.object({
  invitationIds: zod
    .array(zod.uuid().describe('UUID v4 identifier'))
    .max(resolveChatParticipantsBodyInvitationIdsMax)
    .default(resolveChatParticipantsBodyInvitationIdsDefault)
    .describe("Core invitation uuids (from the roster's invitations array) to describe"),
  reachThreadId: zod
    .uuid()
    .optional()
    .describe(
      "The thread being shown. When it is a group's own chat, each resolved actor carries groupRole, for a caller who is in that group",
    ),
  reachUserIds: zod
    .array(zod.uuid())
    .max(resolveChatParticipantsBodyReachUserIdsMax)
    .default(resolveChatParticipantsBodyReachUserIdsDefault)
    .describe('Reach user ids from a thread roster to name'),
});

export type ResolveChatParticipantsBody = zod.input<typeof ResolveChatParticipantsBody>;
export type ResolveChatParticipantsBodyOutput = zod.output<typeof ResolveChatParticipantsBody>;
